<template>
  <div class="entity-info-item">
    <span class="entity-info-label">{{ label }}：</span>
    <slot>
      <span class="entity-info-value">{{ displayValue }}</span>
    </slot>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'EntityInfoItem',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: null },
  },
  computed: {
    displayValue(): string {
      if (this.value == null) return '—';
      const text = String(this.value).trim();
      return text || '—';
    },
  },
});
</script>

<style lang="scss" scoped>
.entity-info-item {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 8px;
  align-items: baseline;
  min-width: 0;
  line-height: 1.45;
}

.entity-info-label {
  flex: 0 0 auto;
  font-size: 13px;
  color: $color-text-secondary;
}

.entity-info-value {
  font-size: 13.5px;
  font-weight: 500;
  color: $color-text;
  word-break: break-all;
}
</style>
